module.exports = __webpack_public_path__ + "static/img/Hussar_development-face.6313643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/Hussar_development-face.png
// module id = 0Y73
// module chunks = 0